import { createTheme } from '@mui/material/styles';

const theme = createTheme({
    components: {
        MuiAccordion: {
            defaultProps: {
                TransitionProps: {
                    // unmountOnExit speeds up the app UI immensely 
                    // because we have a lot of data that folds and expands
                    // https://mui.com/material-ui/react-accordion/#performance
                    unmountOnExit: true
                }
            }
        },
        MuiDrawer: {
            styleOverrides: {
                paper: {
                    width: "auto !important",
                },
            },
        },
        MuiPaper: {
            styleOverrides: {
                root: {
                    width: "auto", // Allow dynamic width
                },
            },
        },
    },
    palette: {
        primary: {
            main: '#212023ff',
        },
        secondary: {
            main: '#e7e7e7ff',
        },
        error: {
            main: '#fc5442',
        },
    },
    typography: {
        h1: {
            fontSize: '2rem',
        },
        body1: {
            fontSize: '1rem',
        },
    },
    breakpoints: {
      values: {
        xs: 0,
        sm: 600,
        md: 600,
        lg: 1200,
        xl: 1536,
      },
    },
});

export default theme;